import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import {
  GetViewerLearningDetailsDocument,
  GetViewerLearningDetailsQuery,
} from '@sandtech-hub-monorepo/ehub-client';

export type AchievementEnrollment = NonNullable<
  GetViewerLearningDetailsQuery['viewer']
>['programEnrollments'][number];

/**
 * GSA program enrollments with something earned: the program certificate or
 * at least one course badge, revoked ones included (they stay visible, marked
 * revoked). Reuses central-hub's learning query rather than a new one.
 */
export const useAchievements = () => {
  const { data, loading } = useQuery(GetViewerLearningDetailsDocument, {
    fetchPolicy: 'cache-and-network',
  });

  const achievements = useMemo(
    () =>
      (data?.viewer?.programEnrollments ?? []).filter(
        (enrollment) =>
          !enrollment.program.isUniversityProgram &&
          (enrollment.program.issuedCertificate ||
            enrollment.plannedCourses.some(
              (course) => course.details?.issuedBadge
            ))
      ),
    [data]
  );

  return { achievements, loading };
};
